<template>
  <section class="title-chunk">
    <h2>
      <slot name="leftIcon" />
      <span class="title" :style="{ fontSize: parseInt(size) + 'px' }">{{ title }}</span>
      <span class="subTitle">{{ secondTitle }}</span>
      <slot name="right" />
    </h2>
    <slot />
  </section>
</template>

<script >
export default {
  props: {
    title: '',
    secondTitle: '',
    size: '16'
  }
};
</script>

<style lang="less" scoped>
.title-chunk {
  h2 {
    color: #262626;
    font-size: 0;
    padding: 14px 16px;
    svg + .title {
      margin-left: 9px;
    }
    .title {
      line-height: 1;
      vertical-align: middle;
    }

    .subTitle {
      font-size: 14px;
      color: #8c8c8c;
    }
  }
}
</style>
